
import React from "react";

const KpiManagement = () => {
  return (
    <div className="space-y-4">
      <h1 className="text-3xl font-bold">KPI Management</h1>
      <p className="text-muted-foreground">
        Set, track, and evaluate key performance indicators for employees and business units.
      </p>
      <div className="bg-background border rounded-md p-8 flex items-center justify-center">
        <p className="text-muted-foreground">KPI management functionality will be implemented here</p>
      </div>
    </div>
  );
};

export default KpiManagement;
